<template>
  <div style="background: white">
    <el-tabs v-model="tab" type="border-card">
      <el-tab-pane
        :key="i"
        v-for="(template, i) in linkInfo.evalTemplate"
        :name="template.tempType"
        :label="template.tempTypeDesc"
      >

      <template v-if="template.tempType !== 'quality_ast_drkt' && template.tempType !== 'quality_ast_mdjt'">
        <div
          v-if="power(userInfo.menuInfoList, 'eval-export') || power(userInfo.menuInfoList, 'eval-export88')"
          style="display: flex; justify-content: flex-end; margin-right: 5px"
        >
          <el-button type="primary" size="small" @click="download"
            >导出</el-button
          >
        </div>
        </template>

        <template v-if="template.tempType == 'quality_ast_drkt' || template.tempType == 'quality_ast_mdjt'">
        <div v-if="isAdmin || isCreate"
          style="display: flex; justify-content: flex-end; margin-right: 5px"
        >
          <el-button type="primary" size="small" @click="templateDRKTRecord(template)"
            >评价记录</el-button
          >
        </div>
        </template>

        <template v-if="template.tempType === 'quality_ast_drkt' || template.tempType === 'quality_ast_mdjt'">
          <ul class="teachers" v-if="pages == 'qualityTeachers'">
            <li
              class="teacher-item"
              v-for="teacher in teachers"
              :key="teacher.id"
            >
              <img :src="teacher.userLogo ? teacher.userLogo : man_teacher" />
              <div class="tname">{{ teacher.userName }}</div>
              <div v-if="teacher.evalCount > 0 && (isAdmin || isCreate)">
                <span style="margin-right: 10px; font-size: 14px;">评价次数：{{ teacher.evalCount }}</span>
                <span style="margin-right: 10px; font-size: 14px;">平均得分：{{ teacher.avgScore }}</span>
                <span style="margin-right: 30px; font-size: 14px;">评价得分：{{ teacher.evalScore }}</span>
              </div>
              <div class="tact">
                <template>
                  <el-badge
                    v-if="teacher.isSign == 0 && teacher.userType != 2"
                    value="未评"
                    class="item"
                    type="info"
                  >
                    <el-button icon="el-icon-edit" size="small" disabled
                      >未签到</el-button
                    >
                  </el-badge>
                  <el-badge
                    v-else
                    :value="teacher.isLeaderEval == 1 ? '已评' : '未评'"
                    class="item"
                    :type="teacher.isLeaderEval == 1 ? 'success' : 'info'"
                  >
                    <el-button
                      icon="el-icon-edit"
                      size="small"
                      @click="templateDRKT(template, teacher)"
                      >评价
                    </el-button>
                  </el-badge>
                </template>
              </div>
            </li>
          </ul>
          <ul class="px-md" v-else-if="pages == 'qualityContent'">
            <el-button size="small" @click="clickBack('qualityTeachers')"
              >返回上一步</el-button
            >
            <!-- <p class="temp-name">{{ template.tempName }}</p> -->
            <iframe
            ref="autoHeightIframe"
              :src="iframeSrcDRKT"
              width="100%"
              height="500px"
              style="border: none"
            ></iframe>

          </ul>
        </template>

        <template v-if="template.tempType === 'eval'">
          <ul class="teachers" v-if="pages == 'evalTeachers'">
            <li
              class="teacher-item"
              v-for="teacher in teachers"
              :key="teacher.id"
            >
              <img :src="teacher.userLogo ? teacher.userLogo : man_teacher" />
              <div class="tname">{{ teacher.userName }}</div>
              <div class="tact">
                <template v-if="isAdmin">
                  <el-badge
                    v-if="teacher.isSign == 0"
                    value="未评"
                    class="item"
                    type="info"
                  >
                    <el-button icon="el-icon-edit" size="small" disabled
                      >未签到</el-button
                    >
                  </el-badge>
                  <el-badge
                    v-else
                    :value="teacher.isLeaderEval == 1 ? '已评' : '未评'"
                    class="item"
                    :type="teacher.isLeaderEval == 1 ? 'success' : 'info'"
                  >
                    <el-button
                      icon="el-icon-edit"
                      size="small"
                      @click="templateEval(template, teacher, 1)"
                      >组长评
                    </el-button>
                  </el-badge>
                </template>
              </div>
            </li>
          </ul>
          <ul class="px-md" v-else-if="pages == 'evalContent'">
            <el-button size="small" @click="pages = 'evalTeachers'"
              >返回上一步</el-button
            >
            <p class="temp-name">{{ template.tempName }}</p>
            <li class="ques-item" v-for="(content, index) in result.eval">
              <p class="text-subtitle2">
                {{ index + 1 }}.{{ content.optContent }}
              </p>
              <div class="text-center" v-if="content.optType == 'objective'">
                <div class="objective-content" v-if="content.isSubmit != 1">
                  <el-input-number
                    size="small"
                    v-model="content.answer"
                    :min="1"
                    :max="content.optScore"
                  >
                  </el-input-number>
                </div>
                <template v-else>
                  <!-- <span class="eval-result">自评：{{ content.answer || '-' }}</span> -->
                  <span class="eval-result ml-md"
                    >组长评:{{ content.leaderAnswer || "-" }}</span
                  >
                </template>
              </div>
            </li>
            <li header class="text-center py-sm" v-show="!loading">
              <el-button
                size="small"
                style="margin: 30px auto"
                v-if="result.isSubmit == '0'"
                type="primary"
                @click="subEvalResult(template)"
                >提交</el-button
              >
              <table v-else flat class="result-table">
                <thead>
                  <tr>
                    <!-- <th class="text-center">总分</th> -->
                    <!-- <th class="text-center">自评分</th> -->
                    <th class="text-center">组长评分</th>
                    <th class="text-center">等级</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <!-- <td class="text-center">{{ evalResult.total }}</td>
										<td class="text-center">{{ evalResult.answer }}</td>-->
                    <td class="text-center">{{ evalResult.leaderAnswer }}</td>
                    <td class="text-center">{{ evalResult.ranks }}</td>
                  </tr>
                </tbody>
              </table>
            </li>
          </ul>
        </template>
        <template v-else-if="template.tempType === 'observed'">
          <template v-if="mainTeacher.length > 0">
            <div class="row px-md">
              <div
                :class="[
                  'ot-item',
                  teacher.userId == currentTeacher.userId
                    ? 'active-teacher'
                    : '',
                ]"
                v-for="teacher in mainTeacher"
                :key="teacher.id"
                @click="templateEval(template, teacher)"
              >
                <div class="teacher-box">
                  <img
                    :src="teacher.userLogo ? teacher.userLogo : man_teacher"
                  />
                </div>
                <div class="text-center text-subtitle2 tn">
                  {{ teacher.userName }}
                </div>
              </div>
            </div>
            <ul class="px-md">
              <p class="temp-name">{{ template.tempName }}</p>
              <template v-if="result.isSubmit == '1'">
                <div style="height: 40vh">
                  <echarts :option="reportOpt"></echarts>
                </div>
                <p header class="eval-result-t">您的评价</p>
              </template>
              <li
                class="ques-item"
                v-for="(content, index) in result.eval"
                :key="content.id"
              >
                <p class="text-subtitle2">
                  {{ index + 1 }}.
                  <span v-if="content.optClassify1"
                    >【{{ content.optClassify1 }}】</span
                  >
                  <span v-if="content.optClassify2"
                    >【{{ content.optClassify2 }}】</span
                  >
                  {{ content.optContent }}
                </p>
                <div class v-if="content.optType == 'objective'">
                  <el-radio-group
                    v-model="content.answer"
                    :disabled="result.isSubmit == '1'"
                  >
                    <el-radio
                      :label="result.isSubmit == '1' ? `${c}` : c"
                      :key="c"
                      v-for="c in content.optScore"
                      >{{ c }}分
                    </el-radio>
                  </el-radio-group>
                </div>
                <div v-else-if="content.optType == 'subjective'">
                  <el-input
                    :disabled="result.isSubmit == '1'"
                    type="textarea"
                    autosize
                    v-model="content.answer"
                    placeholder="输入您的想法，最多2000字"
                    maxlength="2000"
                    show-word-limit
                  ></el-input>
                </div>
              </li>

              <div v-show="!loading" class="result-row">
                <div>总评分</div>
                <div>
                  评价等第：{{ evalResult.ranks }} &nbsp; &nbsp; &nbsp;
                  &nbsp;分数：{{ evalResult.total }}
                </div>
              </div>

              <div
                header
                class="text-center"
                style="padding: 20px 0"
                v-if="result.isSubmit == '0'"
              >
                <el-button
                  v-show="!loading"
                  type="primary"
                  @click="subEvalResult(template)"
                  >提交</el-button
                >
              </div>
              <template v-else>
                <p header class="eval-result-t">评价与建议</p>
                <li
                  class="suggest-item"
                  v-for="sub in result.subjective"
                  :key="sub.id"
                >
                  <img :src="sub.userLogo ? sub.userLogo : man_teacher" />
                  <div class="suggest-body">
                    <p>
                      {{ sub.createName }}
                      <span class="text-caption" style="float: right">{{
                        sub.createTime
                      }}</span>
                    </p>
                    <p caption>{{ sub.answer }}</p>
                  </div>
                </li>
              </template>
            </ul>
          </template>
          <div v-else-if="!loading" class="eval-result-t">
            本次活动的主讲教师非本校教师，无需评价！
          </div>
        </template>
        <template v-else-if="template.tempType === 'cy_observed_1'">
          <template v-if="mainTeacher.length > 0">
            <div class="row px-md">
              <div
                :class="[
                  'ot-item',
                  teacher.userId == currentTeacher.userId
                    ? 'active-teacher'
                    : '',
                ]"
                :key="teacher.id"
                v-for="teacher in mainTeacher"
                @click="templateEvalCY(template, teacher, 'cy_observed_1')"
              >
                <div class="teacher-box">
                  <img
                    :src="teacher.userLogo ? teacher.userLogo : man_teacher"
                  />
                </div>
                <div class="text-center text-subtitle2 tn">
                  {{ teacher.userName }}
                </div>
              </div>
            </div>
            <ul class="px-md">
              <p class="temp-name">{{ template.tempName }}</p>
              <el-form
                v-if="isCurSpeacker"
                :model="evalTable"
                :rules="rules"
                label-width="200px"
                ref="evalTable"
              >
                <el-row
                  type="flex"
                  justify="start"
                  style="padding: 0; margin-right: 8px"
                >
                  <el-form-item label="班级" required>
                    <el-col :span="8">
                      <el-form-item
                        required
                        class="filter-row mb-sm"
                        prop="grade"
                      >
                        <el-select
                          v-model="evalTable.grade"
                          placeholder="请选择年级"
                          value-key="gradeName"
                          @change="onGradeChange"
                        >
                          <el-option
                            v-for="item in gradeOptions"
                            :key="item.gradeName"
                            :label="item.gradeName"
                            :value="{
                              grade: item.grade,
                              gradeName: item.gradeName,
                            }"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8" :offset="1">
                      <el-form-item class="filter-row mb-2px" prop="className">
                        <el-select
                          v-model="evalTable.className"
                          placeholder="请选择班级"
                          value-key="className"
                          clearable
                        >
                          <el-option
                            v-for="item in classOptions"
                            :key="item.classCode"
                            :label="item.className"
                            :value="item.className"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-form-item>
                </el-row>
                <el-form-item label="学科" prop="discipline">
                  <el-select
                    v-model="evalTable.discipline"
                    clearable
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="i in disciplineOptions"
                      :key="i.id"
                      :label="i.disciplineName"
                      :value="i.disciplineName"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="课题" prop="topic">
                  <el-input
                    v-model="evalTable.topic"
                    clearable
                    placeholder="请输入"
                    maxlength="100"
                    show-word-limit
                    style="white-space: pre-wrap"
                  >
                  </el-input>
                </el-form-item>
                <el-form-item label="类型" prop="type">
                  <el-radio-group v-model="evalTable.type">
                    <el-radio label="公开"></el-radio>
                    <el-radio label="自报"></el-radio>
                    <el-radio label="家常"></el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="开课级别" prop="level">
                  <el-select
                    v-model="evalTable.level"
                    clearable
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="i in levelOptions"
                      :key="i"
                      :label="i"
                      :value="i"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button
                    v-show="!loading"
                    type="primary"
                    @click="onSubmit(template, 'evalTable')"
                    >提交</el-button
                  >
                </el-form-item>
              </el-form>
              <li
                v-else-if="isSubmited || !isCurSpeacker"
                style="font-size: 16px"
              >
                <el-row type="flex">
                  <el-col :span="8"
                    >班级：{{ evalCYResult.gradeName
                    }}{{ evalCYResult.className }}</el-col
                  >
                  <el-col :span="8">学科：{{ evalCYResult.discipline }}</el-col>
                  <el-col :span="8"
                    >执教者：{{ currentTeacher.userName }}</el-col
                  >
                </el-row>
                <el-row>
                  <el-col :span="16">课题：{{ evalCYResult.topic }}</el-col>
                  <el-col :span="8">执教时间：{{ teacherTime }}</el-col>
                </el-row>
                <el-row>
                  <el-col :span="16">类型：{{ evalCYResult.type }}</el-col>
                  <el-col :span="8">开课级别：{{ evalCYResult.level }}</el-col>
                </el-row>
              </li>
              <el-divider></el-divider>
              <template v-if="!isCurSpeacker && !isAdmin && !isResearch">
                <li
                  v-for="object in evalList.objective"
                  :key="object.name"
                  style="font-size: 16px"
                >
                  <h2 class="one-title">{{ object.name }}</h2>
                  <div
                    v-for="(option, index) in object.list"
                    :key="option.optCode"
                  >
                    <p class="text-subtitle2">
                      {{ index + 1 }}.
                      <span v-if="option.optClassify2"
                        >【{{ option.optClassify2 }}】</span
                      >
                      {{ option.optContent }}
                    </p>
                    <el-radio-group
                      v-model="option.answer"
                      :disabled="isSubmitEval"
                      style="margin-left: 16px"
                    >
                      <el-radio :label="8"> A</el-radio>
                      <el-radio :label="7"> B</el-radio>
                      <el-radio :label="5"> C</el-radio>
                      <el-radio :label="4"> D</el-radio>
                    </el-radio-group>
                  </div>
                </li>
                <template>
                  <p header class="one-title eval-result-t">评价与建议</p>
                  <li v-for="sub in evalList.subjective" :key="sub.optCode">
                    <el-input
                      autosize
                      placeholder="输入您的想法，最多2000字"
                      type="textarea"
                      v-model="sub.answer"
                      show-word-limit
                      maxlength="2000"
                      :readonly="isSubmitEval"
                    >
                    </el-input>
                  </li>
                  <div
                    header
                    class="text-center"
                    style="padding: 20px 0"
                    v-show="!isSubmitEval"
                  >
                    <el-button
                      v-show="!loading"
                      type="primary"
                      @click="subEval(template)"
                      >提交</el-button
                    >
                  </div>
                </template>
              </template>

              <template v-if="isAdmin || isResearch">
                <el-row>
                  <el-col :span="5">
                    <el-card shadow="always">
                      平均得分&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{
                        statictis.avgScore
                      }}
                    </el-card>
                  </el-col>
                  <el-col :push="2" :span="8" style="min-height: 300px">
                    <echarts
                      :option="option1"
                      style="min-height: 300px"
                    ></echarts>
                  </el-col>
                </el-row>
                <el-table
                  :data="statictis.objectiveList"
                  :span-method="spanMethod"
                  border
                  :show-header="false"
                  style="width: 100%; margin-top: 20px"
                  row-key="optCode"
                >
                  <el-table-column
                    prop="optClassify1"
                    align="center"
                    width="180"
                  >
                  </el-table-column>
                  <el-table-column prop="optClassify2" align="center">
                  </el-table-column>
                  <el-table-column align="center" prop="optScore">
                  </el-table-column>
                </el-table>
                <template>
                  <div
                    v-for="subject in statictis.subjectiveList"
                    :key="subject.code"
                  >
                    <p header class="one-title eval-result-t">
                      {{ subject.name }}
                    </p>
                    <li
                      class="suggest-item"
                      v-for="sub in subject.list"
                      :key="sub.id"
                    >
                      <img :src="sub.userLogo ? sub.userLogo : man_teacher" />
                      <div class="suggest-body">
                        <p>
                          {{ sub.createName }}
                          <span class="text-caption" style="float: right">{{
                            sub.createTime
                          }}</span>
                        </p>
                        <p caption>{{ sub.answer }}</p>
                      </div>
                    </li>
                  </div>
                </template>
              </template>
            </ul>
          </template>
        </template>
        <template v-else-if="template.tempType === 'cy_observed_2'">
          <template v-if="mainTeacher.length > 0">
            <div class="row px-md">
              <div
                :class="[
                  'ot-item',
                  teacher.userId == currentTeacher.userId
                    ? 'active-teacher'
                    : '',
                ]"
                v-for="teacher in mainTeacher"
                @click="templateEvalCY(template, teacher, 'cy_observed_2')"
                :key="teacher.id"
              >
                <div class="teacher-box">
                  <img
                    :src="teacher.userLogo ? teacher.userLogo : man_teacher"
                  />
                </div>
                <div class="text-center text-subtitle2 tn">
                  {{ teacher.userName }}
                </div>
              </div>
            </div>
            <ul class="px-md">
              <p class="temp-name">{{ template.tempName }}</p>
              <el-form
                v-if="isCurSpeacker"
                :model="evalTable"
                :rules="rules"
                label-width="200px"
                ref="evalTable2"
              >
                <el-row
                  type="flex"
                  justify="start"
                  style="padding: 0; margin-right: 8px"
                >
                  <el-form-item label="班级" required>
                    <el-col :span="8">
                      <el-form-item
                        required
                        class="filter-row mb-sm"
                        prop="grade"
                      >
                        <el-select
                          v-model="evalTable.grade"
                          placeholder="请选择年级"
                          value-key="gradeName"
                          @change="onGradeChange"
                        >
                          <el-option
                            v-for="item in gradeOptions"
                            :key="item.gradeName"
                            :label="item.gradeName"
                            :value="{
                              grade: item.grade,
                              gradeName: item.gradeName,
                            }"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8" :offset="1">
                      <el-form-item class="filter-row mb-2px" prop="className">
                        <el-select
                          v-model="evalTable.className"
                          placeholder="请选择班级"
                          value-key="className"
                          clearable
                        >
                          <el-option
                            v-for="item in classOptions"
                            :key="item.classCode"
                            :label="item.className"
                            :value="item.className"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-form-item>
                </el-row>

                <el-form-item label="教材" prop="textbook">
                  <el-input
                    v-model="evalTable.textbook"
                    clearable
                    placeholder="请输入"
                    maxlength="100"
                    show-word-limit
                    style="white-space: pre-wrap"
                  >
                  </el-input>
                </el-form-item>
                <el-form-item label="课题" prop="topic">
                  <el-input
                    v-model="evalTable.topic"
                    clearable
                    placeholder="请输入"
                    maxlength="100"
                    show-word-limit
                    style="white-space: pre-wrap"
                  >
                  </el-input>
                </el-form-item>
                <el-form-item label="听课范围" prop="scope">
                  <el-radio-group v-model="evalTable.scope">
                    <el-radio label="公开"></el-radio>
                    <el-radio label="自报"></el-radio>
                    <el-radio label="家常"></el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="单元核心目标" prop="coreTarget">
                  <el-input
                    type="textarea"
                    autosize
                    v-model="evalTable.coreTarget"
                    maxlength="1000"
                    show-word-limit
                    style="white-space: pre-wrap"
                  ></el-input>
                </el-form-item>
                <el-form-item label="本课教学关联单元语文要素的重点目标" prop="task">
                  <el-input
                    type="textarea"
                    autosize
                    v-model="evalTable.task"
                    maxlength="1000"
                    show-word-limit
                    style="white-space: pre-wrap"
                  ></el-input>
                </el-form-item>
                <el-form-item label="本课教学目标" prop="totalTarget">
                  <el-input
                    type="textarea"
                    autosize
                    v-model="evalTable.totalTarget"
                    maxlength="1000"
                    show-word-limit
                    style="white-space: pre-wrap"
                  ></el-input>
                </el-form-item>
                <el-form-item label="课时教学目标" prop="currentTarget">
                  <el-input
                    type="textarea"
                    autosize
                    v-model="evalTable.currentTarget"
                    maxlength="1000"
                    show-word-limit
                    style="white-space: pre-wrap"
                  ></el-input>
                </el-form-item>

                <el-form-item>
                  <el-button
                    v-show="!loading"
                    type="primary"
                    @click="onSubmit(template, 'evalTable2')"
                    >提交</el-button
                  >
                </el-form-item>
              </el-form>
              <li
                v-else-if="isSubmited || !isCurSpeacker"
                style="font-size: 16px"
              >
                <el-row type="flex">
                  <el-col :span="12"
                    >班级：{{ evalCYResult.gradeName
                    }}{{ evalCYResult.className }}</el-col
                  >
                  <el-col :span="12"
                    >执教者：{{ currentTeacher.userName }}</el-col
                  >
                </el-row>
                <el-row>
                  <el-col :span="12">课题：{{ evalCYResult.topic }}</el-col>
                  <el-col :span="12">教材：{{ evalCYResult.textbook }}</el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">执教时间：{{ teacherTime }}</el-col>
                  <el-col :span="12">听课范围：{{ evalCYResult.scope }}</el-col>
                </el-row>
                <el-divider></el-divider>
                <el-row>
                  <h2 class="one-title">单元核心目标</h2>
                  <p style="min-height: 30px; white-space: pre-wrap">
                    {{ evalCYResult.coreTarget }}
                  </p>
                </el-row>
                <el-row>
                  <h2 class="one-title">本课教学关联单元语文要素的重点目标</h2>
                  <p style="min-height: 30px; white-space: pre-wrap">
                    {{ evalCYResult.task }}
                  </p>
                </el-row>
                <el-row>
                  <h2 class="one-title">本课教学目标</h2>
                  <p style="min-height: 30px; white-space: pre-wrap">
                    {{ evalCYResult.totalTarget }}
                  </p>
                </el-row>
                <el-row>
                  <h2 class="one-title">课时教学目标</h2>
                  <p style="min-height: 30px; white-space: pre-wrap">
                    {{ evalCYResult.currentTarget }}
                  </p>
                </el-row>
                <el-divider></el-divider>
              </li>
              <template v-if="!isCurSpeacker && !isAdmin && !isResearch">
                <li
                  v-for="object in evalList.objective"
                  :key="object.name"
                  style="font-size: 16px"
                >
                  <h2 class="one-title">{{ object.name }}</h2>
                  <div
                    v-for="(option, index) in object.list"
                    :key="option.optCode"
                  >
                    <p class="text-subtitle2">
                      {{ index + 1 }}.
                      <span v-if="option.optClassify2"
                        >【{{ option.optClassify2 }}】</span
                      >
                      {{ option.optContent }}
                    </p>
                    <el-radio-group
                      v-model="option.answer"
                      :disabled="isSubmitEval"
                      style="margin-left: 16px"
                    >
                      <el-radio :label="18"> 好</el-radio>
                      <el-radio :label="15"> 较好</el-radio>
                      <el-radio :label="12"> 有欠缺</el-radio>
                    </el-radio-group>
                  </div>
                </li>
                <template>
                  <li v-for="sub in evalList.subjective" :key="sub.optCode">
                    <p header class="one-title">{{ sub.name }}</p>
                    <div
                      v-for="(option, index) in sub.list"
                      :key="option.optCode"
                    >
                      <p header>{{ index + 1 }}.{{ option.optContent }}</p>
                      <el-input
                        autosize
                        placeholder="输入您的想法，最多2000字"
                        maxlength="2000"
                        show-word-limit
                        type="textarea"
                        v-model="option.answer"
                        :readonly="isSubmitEval"
                      >
                      </el-input>
                    </div>
                  </li>
                  <div
                    header
                    class="text-center"
                    style="padding: 20px 0"
                    v-show="!isSubmitEval"
                  >
                    <el-button
                      v-show="!loading"
                      type="primary"
                      @click="subEval(template)"
                      >提交</el-button
                    >
                  </div>
                </template>
              </template>
              <template v-if="isAdmin || isResearch">
                <el-row>
                  <el-col :span="5">
                    <el-card shadow="always">
                      平均得分&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{
                        statictis.avgScore
                      }}
                    </el-card>
                  </el-col>
                  <el-col :push="2" :span="8" style="min-height: 300px">
                    <echarts
                      :option="option1"
                      style="min-height: 300px"
                    ></echarts>
                  </el-col>
                </el-row>
                <el-table
                  :data="statictis.objectiveList"
                  border
                  :show-header="false"
                  style="width: 100%; margin-top: 20px"
                  row-key="optCode"
                >
                  <el-table-column prop="optContent" align="center" width="180">
                  </el-table-column>
                  <el-table-column align="center" prop="optScore">
                  </el-table-column>
                </el-table>
                <template>
                  <el-tabs
                    v-model="evalActiveName"
                    type="card"
                    style="margin: 50px 0"
                  >
                    <el-tab-pane
                      :label="subject.name"
                      :name="subject.code"
                      v-for="subject in statictis.subjectiveList"
                      :key="subject.code"
                    >
                      <li
                        class="suggest-item"
                        v-for="sub in currentList"
                        :key="sub.id"
                      >
                        <img :src="sub.userLogo ? sub.userLogo : man_teacher" />
                        <div class="suggest-body">
                          <p>
                            {{ sub.createName }}
                            <span class="text-caption" style="float: right">{{
                              sub.createTime
                            }}</span>
                          </p>
                          <p caption>{{ sub.answer }}</p>
                        </div>
                      </li>
                    </el-tab-pane>
                  </el-tabs>
                  <!-- <div v-for="(subject) in statictis.subjectiveList" :key="subject.code">
                        <p header class="one-title eval-result-t">{{subject.name}}</p>
                        <li class="suggest-item" v-for="sub in subject.list" :key="sub.id">
                          <img :src="sub.userLogo ? sub.userLogo : man_teacher" />
                          <div class="suggest-body">
                            <p>
                              {{ sub.createName }}
                              <span class="text-caption" style="float: right;">{{ sub.createTime }}</span>
                            </p>
                            <p caption>{{ sub.answer }}</p>
                          </div>
                        </li>
                      </div> -->
                </template>
              </template>
            </ul>
          </template>
        </template>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import TplDetail from "@/templates/TplDetail.vue";
import { postData, getData, postJson } from "@/http/fetch.js";
import { mapState } from "vuex";
import Echarts from "../../components/echarts.vue";
import { downloadFile, NoDataOption } from "../../utils";
import { power } from "@/utils/index.js";
import { getSpanMethod } from "../../utils/table";

export default {
  components: {
    TplDetail,
    Echarts,
  },
  props: {
    linkInfo: "",
  },
  computed: {
    currentList() {
      return this.statictis.subjectiveList.find(
        (u) => u.code == this.evalActiveName
      )?.list;
    },
    spanMethod: {
      get() {
        return (this.spanMethod = getSpanMethod(
          this.statictis.objectiveList,
          ["optClassify1"],
          ["optClassify1"]
        ));
      },
      set(val) {
        return val;
      },
    },
    ...mapState(["userInfo"]),
    isAdmin() {
      return (
        this.userInfo.roleCodes.includes("admin") ||
        this.userInfo.userId == this.linkInfo.createBy
      );
    },
    isResearch() {
      return this.userInfo.roleCodes.includes("research");
    },
    isCurSpeacker() {
      return this.userInfo.userId == this.currentTeacher.userId;
    },
    teacherTime() {
      return sessionStorage.getItem("startDate")?.split(" ")[0];
    },
    module() {
      let m = this.$route.query.moduleType;
      switch (m) {
        case "eduResearch":
          return "research";
        case "train":
          return "training";
        case "topicResearch":
          return "topic";
        default:
          return m;
      }
    },
    evalResult() {
      let m = 0,
        n = 0,
        total = "-",
        rank = "-";

      if (this.tab == "eval") {
        this.result.eval.forEach((f) => {
          if (f.optType == "subjective") {
            return;
          }
          m += parseFloat(f.answer || 0);
          n += parseFloat(f.leaderAnswer || 0);
        });
        if (n > 0) {
          total = n;
          if (total >= 90) {
            rank = "A";
          } else if (total < 90 && total >= 80) {
            rank = "B";
          } else if (total < 80 && total >= 70) {
            rank = "C";
          } else {
            rank = "D";
          }
        } else {
          total = "-";
          rank = "-";
        }
      } else if (this.tab == "observed") {
        this.result.eval.forEach((f) => {
          if (f.optType == "subjective") {
            return;
          }
          m += parseFloat(f.answer || 0);
          n += parseFloat(f.leaderAnswer || 0);
        });
        total = m;
        if (total >= 85) {
          rank = "优";
        } else if (total < 85 && total >= 75) {
          rank = "良";
        } else if (total < 75 && total >= 60) {
          rank = "中";
        } else if (total < 60 && total > 0) {
          rank = "差";
        } else {
          rank = "-";
        }
      }
      return {
        total,
        rank: this.tab == "eval" ? (n > 0 ? rank : "-") : rank,
        answer: m.toFixed(1),
        leaderAnswer: n.toFixed(1),
      };
    },
    reportOpt() {
      let option = { ...NoDataOption };
      if (this.result.pieChart.length > 0 && this.result.histogram.length > 0) {
        option = {
          grid: { left: "50%" },
          xAxis: { type: "category" },
          yAxis: { type: "value" },
          series: [
            {
              type: "pie",
              label: { show: true, formatter: "{b}{c}%", position: "inside" },
              data: this.result.pieChart,
              center: ["25%", "50%"],
              radius: "45%",
            },
            {
              type: "bar",
              data: this.result.histogram,
              color: "#2ec7c9",
              label: {
                show: true,
                position: "top",
              },
            },
          ],
        };
      }
      return option;
    },
    option1() {
      let option = { ...NoDataOption };
      if (
        this.statictis.radarMap.indicator.length > 0 &&
        this.statictis.radarMap.value.length > 0
      ) {
        option = {
          title: {
            show: false,
          },
          color: ["#1c98ff"],
          radar: {
            indicator: this.statictis.radarMap.indicator,
          },
          series: [
            {
              type: "radar",
              data: [
                {
                  value: this.statictis.radarMap.value,
                },
              ],
            },
          ],
        };
      }
      return option;
    },
  },
  data() {
    return {
      tab: "eval",
      pages: "evalTeachers",
      menuCode : "",
      iframeSrcDRKT: "",
      teachers: [],
      currentTeacher: {
        userId: "",
      },
      isCreate: false,
      man_teacher: require("@/assets/image/other/man_teacher.png"),
      mainTeacher: [],
      loading: false,
      result: {
        evalType: 0, //评价类型：0：自评，1：组长评
        eval: [],
        isSubmit: "0",
        histogram: [],
        pieChart: [],
        isSign: 0,
      },
      evalTable: {
        grade: "",
        className: "",
        discipline: "",
        topic: "",
        type: "",
        level: "",
        textbook: "",
        scope: "",
        coreTarget: "",
        task: "",
        totalTarget: "",
        currentTarget: "",
      },
      gradeOptions: [],
      classOptions: [],
      disciplineOptions: [],
      levelOptions: ["市级", "区级", "校级", "教研组级"],
      rules: {
        grade: [{ required: true, message: "请选择年级", trigger: "blur" }],
        classCode: [
          { required: true, message: "请选择班级", trigger: "change" },
        ],
        discipline: [
          { required: true, message: "请选择学科", trigger: "change" },
        ],
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
        scope: [
          { required: true, message: "请选择听课范围", trigger: "change" },
        ],
        level: [{ required: true, message: "请选择开课级别", trigger: "blur" }],
        topic: [{ required: true, message: "请输入课题", trigger: "blur" }],
        textbook: [{ required: true, message: "请输入教材", trigger: "blur" }],
        coreTarget: [
          { required: true, message: "请输入单元核心目标", trigger: "blur" },
        ],
        task: [
          {
            required: true,
            message: "请输本课教学关联单元语文要素的重点目标",
            trigger: "blur",
          },
        ],
        totalTarget: [
          { required: true, message: "请输入本课教学目标", trigger: "blur" },
        ],
        currentTarget: [
          { required: true, message: "请输入课时教学目标", trigger: "blur" },
        ],
      },
      isSubmited: false,
      isSpeaker: false,
      isSubmitEval: false,
      evalCYResult: {},
      evalList: {
        objective: [],
        subjective: [],
      },
      statictis: {
        avgScore: 0,
        objectiveList: [],
        radarMap: {
          indicator: [],
          value: [],
        },
        subjectiveList: [],
      },
      evalActiveName: "",
    };
  },
  async created() {
    // await this.getActiveUserMapList();
    this.tab = this.linkInfo.evalTemplate[0].tempType;
    this.tabChange();
  },
  mounted() {
    // 监听子页面发送的高度消息
    window.addEventListener("message", this.handleCrossDomainHeight);
  },
  beforeDestroy() {
    window.removeEventListener("message", this.handleCrossDomainHeight);
  },
  methods: {
    power,
    templateDRKT(template, teacher) {
      debugger
      this.pages = "qualityContent";
      let teacherId = teacher.userId;
      let teacherName = teacher.userName;
      if (teacherId == null || teacherId == '' || teacherId == undefined){
        teacherId = teacherName;
      }
      let url = `https://hyx.xueduoduo.com/teaching-dev/?userId=${this.userInfo.userId}&teacherId=${teacherId}&teacherName=${teacherName}&menuType=tdevEval&menuCode=${template.tempType}&className=&groupCode=&actCode=${this.linkInfo.actCode}&nodeCode=${this.linkInfo.nodeCode}&content=${teacher.content}`;
      console.log("new url:"+url)
      this.iframeSrcDRKT =  url
    },
    templateDRKTRecord(template) {
      this.pages = "qualityContent";
      let url = `https://hyx.xueduoduo.com/teaching-dev/?userId=${this.userInfo.userId}&menuType=tdevRecord&menuCode=${template.tempType}&className=&groupCode=&actCode=${this.linkInfo.actCode}&nodeCode=${this.linkInfo.nodeCode}`;
      console.log("new url:"+url)
      this.iframeSrcDRKT =  url
    },
    // iframe加载完成后，通知子页面"可以传递高度了"
    initIframe() {
      const iframe = this.$refs.autoHeightIframe;
      if (!iframe) return;
      // 向子页面发送初始化消息（指定子页面域名，增强安全性）
    },
    clickBack(page){
      this.pages =  page
      this.tabChange();

    },
    // 接收子页面传递的高度并设置
    handleCrossDomainHeight(e) {
      // 1. 验证消息来源（必须！防止恶意网站伪造消息）
      // 2. 接收子页面传递的高度

      if (e.data.type === "sendHeight" && e.data.height) {
        const iframe = this.$refs.autoHeightIframe;
        // 设置高度（加冗余）
        iframe.style.height = `${e.data.height + 20}px`;
      }
    },
    templateEval(template, teacher, evalType) {
      this.result.evalType = evalType;
      this.result.eval = [];
      this.result.histogram = [];
      this.result.pieChart = [];
      this.result.subjective = [];
      this.result.isSubmit = 0;
      this.result.isSign = 0;
      this.currentTeacher = teacher;
      if (template.tempType == "eval") {
        this.pages = "evalContent";
      }
      this.loading = true;
      postJson("/node/getNodeTopicEvalResult", {
        actCode: this.linkInfo.actCode,
        nodeCode: this.linkInfo.nodeCode,
        tempType: template.tempType,
        tempCode: template.tempCode,
        schoolCode: this.userInfo.schoolCode,
        roleCode:
          template.tempType == "observed" ? null : this.userInfo.roleCodes,
        teacherId: teacher.userId,
        userType: teacher.userType,
        evalType,
      })
        .then((res) => {
          if (res.isSubmit) {
            this.result.eval = res.eval;
          } else {
            this.result.eval = res.eval.map((m) => {
              if (m.optScore) {
                m.answer = 1;
                // m.answer = parseInt(m.optScore);
              } else {
                m.answer = "";
              }
              // console.log(typeof m.answer)
              return m;
            });
          }
          this.result.histogram = res.histogram || [];
          this.result.pieChart = res.pieChart || [];
          this.result.subjective = res.subjective || [];
          this.result.isSubmit = res.isSubmit || 0;
          this.result.isSign = res.isSign || 0;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async getObservedTempOptionStatistics(template) {
      try {
        let res = await postJson("/node/getObservedTempOptionStatistics", {
          actCode: this.linkInfo.actCode,
          nodeCode: this.linkInfo.nodeCode,
          teacherId: this.currentTeacher.userId,
          tempType: template.tempType,
          tempCode: template.tempCode,
        });
        this.statictis.avgScore = res.avgScore;
        this.statictis.objectiveList = res.objectiveList;
        this.statictis.radarMap = res.radarMap;
        this.statictis.subjectiveList = res.subjectiveList;
        if (res.subjectiveList.length > 0) {
          this.evalActiveName = res.subjectiveList[0].code;
        }
      } catch (error) {}
    },
    async templateEvalCY(template, teacher, evalType) {
      this.evalTable.grade = {};
      this.evalTable.className = "";
      this.evalTable.discipline = "";
      this.evalTable.topic = "";
      this.evalTable.type = "";
      this.evalTable.level = "";
      this.evalTable.textbook = "";
      this.evalTable.scope = "";
      this.evalTable.coreTarget = "";
      this.evalTable.task = "";
      this.evalTable.totalTarget = "";
      this.evalTable.currentTarget = "";
      this.evalList.objective = [];
      this.evalList.subjective = [];
      this.currentTeacher = teacher;
      this.loading = true;
      this.statictis.avgScore = 0;
      this.statictis.objectiveList = [];
      this.statictis.radarMap.indicator = [];
      this.statictis.radarMap.value = [];
      this.statictis.subjectiveList = [];
      this.isSubmitEval = false;

      await postJson("/node/getNodeEvalObservedInfo", {
        actCode: this.linkInfo.actCode,
        evalCode: template.evalCode,
        nodeCode: this.linkInfo.nodeCode,
        schoolCode: this.userInfo.schoolCode,
        userId: teacher.userId,
      })
        .then((res) => {
          this.isSubmited = Boolean(res.isSubmit);
          this.isSpeaker = Boolean(res.isSpeaker);
          if (this.isSubmited) {
            this.evalCYResult = res.observedDTO;
          } else {
            this.evalCYResult = {};
          }
          if (this.isCurSpeacker) {
            //是主讲人且没有提交
            this.getGradeList();
            this.getDiscipline();
          } else {
            this.getObservedTempOptionInfoList();
          }
          if (this.isSubmited) {
            this.evalTable.grade = {
              grade: res.observedDTO.grade,
              gradeName: res.observedDTO.gradeName,
            };
            if (this.evalTable.grade.grade) {
              this.onGradeChange(this.evalTable.grade);
            }
            this.evalTable.className = res.observedDTO.className;
            if (evalType == "cy_observed_1") {
              this.evalTable.discipline = res.observedDTO.discipline;
              this.evalTable.topic = res.observedDTO.topic;
              this.evalTable.type = res.observedDTO.type;
              this.evalTable.level = res.observedDTO.level;
            } else if (evalType == "cy_observed_2") {
              this.evalTable.topic = res.observedDTO.topic;
              this.evalTable.textbook = res.observedDTO.textbook;
              this.evalTable.scope = res.observedDTO.scope;
              this.evalTable.coreTarget = res.observedDTO.coreTarget;
              this.evalTable.task = res.observedDTO.task;
              this.evalTable.currentTarget = res.observedDTO.currentTarget;
              this.evalTable.totalTarget = res.observedDTO.totalTarget;
            }
            this.evalTable.id = res.observedDTO.id;
          }
        })
        .catch((error) => {
          this.isSubmited = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    subEval(template) {
      let obj = {};
      console.log(this.evalList.subjective);
      if (
        template.tempType == "cy_observed_1" &&
        this.evalList.subjective.some((u) => !u.answer)
      ) {
        this.$message.error(`您未填写您的想法，暂无法提交。`);
        return;
      } else if (
        template.tempType == "cy_observed_2" &&
        this.evalList.subjective &&
        this.evalList.subjective.length == 1 &&
        this.evalList.subjective[0].list.some((u) => !u.answer)
      ) {
        this.$message.error(`您未填写评课与反思的想法，暂无法提交。`);
        return;
      }

      obj.evalResultList = this.evalList.objective
        .map((item) => {
          return item.list.map((u) => ({
            optCode: u.optCode,
            answer: u.answer,
          }));
        })
        .flat();
      if (obj.evalResultList.some((u) => u.answer == 0)) {
        this.$message.error(`您还还未评价完整，暂无法提交。`);
        return;
      }
      let arr = [];
      if (template.tempType == "cy_observed_1") {
        arr = this.evalList.subjective.map((u) => ({
          optCode: u.optCode,
          answer: u.answer,
        }));
      } else {
        arr = this.evalList.subjective[0].list.map((u) => ({
          optCode: u.optCode,
          answer: u.answer,
        }));
      }
      obj.evalResultList = obj.evalResultList.concat(arr);
      (obj.nodeCode = this.linkInfo.nodeCode),
        (obj.actCode = this.linkInfo.actCode),
        (obj.operatorId = this.userInfo.userId),
        (obj.schoolCode = this.userInfo.schoolCode),
        (obj.teacherId = this.currentTeacher.userId),
        (obj.tempCode = template.tempCode),
        (obj.roleCode = this.userInfo.roleCodes),
        (obj.evalCode = template.evalCode);
      postJson("/node/saveNodeTopicEvalResult", obj).then((res) => {
        this.templateEvalCY(template, this.currentTeacher, template.tempType);
        this.$message.success("提交成功！");
      });
    },
    subEvalResult(template) {
      if (template.tempType == "observed" && this.result.isSign == 0) {
        this.$message.error(`您未签到该活动，暂无法提交。`);
        return;
      }
      let evalResultList = [];
      let validate = true;
      this.result.eval.forEach((i, j) => {
        if (!i.answer) {
          validate = false;
          this.$message.error(`第${j + 1}题未完成`);
          return;
        }
        evalResultList.push({
          answer: i.answer,
          optCode: i.optCode,
        });
      });
      if (!validate) return;
      postJson("/node/saveNodeTopicEvalResult", {
        actCode: this.linkInfo.actCode,
        nodeCode: this.linkInfo.nodeCode,
        schoolCode: this.userInfo.schoolCode,
        operatorId: this.userInfo.userId,
        roleCode: this.userInfo.roleCodes,
        tempCode: template.tempCode,
        evalResultList,
        teacherId: this.currentTeacher.userId,
        evalType: this.result.evalType,
      }).then((res) => {
        this.tabChange();
        // this.templateEval(template, this.currentTeacher)
        this.$message.success("提交成功！");
      });
    },
    async getActiveUserMapList(template) {
      this.loading = true;
      let list = await getData(`research/getActiveUserMapEvalList`, {
        actCode: this.linkInfo.actCode,
        nodeCode: this.linkInfo.nodeCode,
        tempType: this.tab,
        operatorId: this.userInfo.userId,
      });
      //用户参与身份，0：主讲教师，1：参与教师，2：外校主讲人，3：主持人
      this.mainTeacher = list.filter((f) => {
        return f.userType == 0;
      });
      this.isCreate = list.some((f) => (f.userType == 3 && f.userId == this.userInfo.userId));
      if (this.tab == "quality_ast_drkt" || this.tab == "quality_ast_mdjt") {
        this.teachers = list.filter((f) => {
          return f.userType == 0 || f.userType == 2;
        });
      }else{
        if (this.isAdmin) {
        this.teachers = list.filter((f) => {
          return f.userType == 1 || f.userType == 0;
        });
      } else {
        this.teachers = list.filter((f) => {
          return f.userId == this.userInfo.userId;
        });
      }
      }

      this.loading = false;
    },
    async getObservedTempOptionInfoList() {
      this.loading = false;
      let template = this.linkInfo.evalTemplate.find(
        (f) => f.tempType == this.tab
      );
      await postJson("/node/getObservedTempOptionInfoList", {
        tempCode: template.tempCode,
        tempType: template.tempType,
        actCode: this.linkInfo.actCode,
        nodeCode: this.linkInfo.nodeCode,
        teacherId: this.currentTeacher.userId,
        userId: this.userInfo.userId,
      }).then((res) => {
        this.isSubmitEval = Boolean(res.isSubmit);
        if (template.tempType == "cy_observed_1") {
          this.evalList.objective = res.tempMap.objective.map((m) => {
            if (m.list.length > 0) {
              m.list = m.list.map((u) => {
                if (u.answer) {
                  u.answer = parseInt(u.answer);
                } else {
                  u.answer = 0;
                }
                return u;
              });
            }
            return m;
          });
          this.evalList.subjective = res.tempMap.subjective;
        } else if (template.tempType == "cy_observed_2") {
          this.evalList.objective = res.tempMap.objective.map((m) => {
            if (m.list.length > 0) {
              m.list = m.list.map((u) => {
                if (u.answer) {
                  u.answer = parseInt(u.answer);
                } else {
                  u.answer = 0;
                }
                return u;
              });
            }
            return m;
          });
          this.evalList.subjective = res.tempMap.subjective.map((m) => {
            if (m.list.length > 0) {
              m.list = m.list.map((u) => {
                if (!u.answer) {
                  u.answer = null;
                }
                return u;
              });
            }
            return m;
          });
        }
        if (
          (this.isAdmin && this.isSubmitEval) ||
          (this.isSubmited && this.isAdmin) ||
          this.isResearch ||
          this.isAdmin
        ) {
          this.getObservedTempOptionStatistics(template);
        }
      });
    },

    async tabChange() {
      if (this.tab === "observed") {
        this.result.isSubmit = 0;
        let template = this.linkInfo.evalTemplate.find(
          (f) => f.tempType == this.tab
        );
        await this.getActiveUserMapList(template);
        if (this.mainTeacher.length > 0) {
          this.currentTeacher = this.mainTeacher[0];
          this.templateEval(template, this.currentTeacher);
        }
      } else if (this.tab === "cy_observed_1") {
        let template = this.linkInfo.evalTemplate.find(
          (f) => f.tempType == this.tab
        );
        await this.getActiveUserMapList(template);
        if (this.mainTeacher.length > 0) {
          this.currentTeacher = this.mainTeacher[0];
          await this.templateEvalCY(
            template,
            this.currentTeacher,
            "cy_observed_1"
          );
        }
      } else if (this.tab === "cy_observed_2") {
        let template = this.linkInfo.evalTemplate.find(
          (f) => f.tempType == this.tab
        );
        await this.getActiveUserMapList(template);
        if (this.mainTeacher.length > 0) {
          this.currentTeacher = this.mainTeacher[0];
          await this.templateEvalCY(
            template,
            this.currentTeacher,
            "cy_observed_2"
          );
        }
      } else if (this.tab === "quality_ast_drkt" || this.tab === "quality_ast_mdjt") {
        this.pages = "qualityTeachers";
        let template = this.linkInfo.evalTemplate.find(
          (f) => f.tempType == this.tab
        );
        await this.getActiveUserMapList(template);
      } else {
        this.pages = "evalTeachers";
        let template = this.linkInfo.evalTemplate.find(
          (f) => f.tempType == this.tab
        );
        await this.getActiveUserMapList(template);
      }
    },
    onSubmit(template, Formname) {
      let that = this;
      this.$refs[Formname][0].validate((valid) => {
        if (valid) {
          let obj = JSON.parse(JSON.stringify(this.evalTable));
          if (template.tempType == "cy_observed_2") {
            delete obj["type"];
            delete obj["level"];
            delete obj["discipline"];
          } else if (template.tempType == "cy_observed_1") {
            delete obj["coreTarget"];
            delete obj["currentTarget"];
            delete obj["task"];
            delete obj["textbook"];
            delete obj["totalTarget"];
          }
          let obj2 = JSON.parse(JSON.stringify(obj.grade));
          obj.grade = obj2.grade;
          obj.gradeName = obj2.gradeName;
          obj.operatorId = this.userInfo.userId;
          obj.schoolCode = this.userInfo.schoolCode;
          obj.actCode = this.linkInfo.actCode;
          obj.nodeCode = this.linkInfo.nodeCode;
          //  let template = this.linkInfo.evalTemplate.find(f => f.tempType == this.tab);
          obj.evalCode = template.evalCode;
          this.loading = true;
          if (this.evalTable.id) obj.id = this.evalTable.id;
          postJson("/node/saveOrUpdateNodeEvalObservedInfo", obj).then(
            (res) => {
              that.$refs[Formname][0].resetFields();
              // that.$refs.evalTable.;
              this.templateEvalCY(
                template,
                this.currentTeacher,
                template.tempType
              );
              this.$message.success("提交成功！");
            }
          );
        } else {
          return false;
        }
      });
    },
    async getGradeList() {
      this.gradeOptions = await postData("/school/getGradeList", {
        schoolCode: this.userInfo?.schoolCode,
      });
      return new Promise((resolve) => {
        resolve();
      });
    },
    async onGradeChange(val) {
      this.classOptions = await getData("/school/getClassInfoList", {
        schoolCode: this.userInfo.schoolCode,
        grade: val.grade,
        pageSize: -1,
        pageNum: 1,
      });
    },
    async getDiscipline() {
      this.disciplineOptions = await postData(
        "/discipline/getDisciplinelList",
        {
          schoolCode: this.userInfo?.schoolCode,
        }
      );
      return new Promise((resolve) => {
        resolve();
      });
    },
    saveAs(blob, name) {
      const save_link = document.createElement("a");
      document.body.appendChild(save_link);
      save_link.style.display = "none";
      save_link.href = blob;
      save_link.download = name;
      save_link.click();
      document.body.removeChild(save_link);
      // return true; // 确认下载完成 后面进行下载记录保存
    },
    download() {
      let template = this.linkInfo.evalTemplate.find(
        (f) => f.tempType == this.tab
      );
      this.$axios
        .post(
          "/node/exportActEvalInfo",
          this.$qs.stringify({
            actCode: this.linkInfo.actCode,
            evalCode: template.evalCode,
            nodeCode: this.linkInfo.nodeCode,
            schoolCode: this.userInfo.schoolCode,
            tempCode: template.tempCode,
            tempType: template.tempType,
            userId: this.currentTeacher.userId,
          }),
          {
            responseType: "blob",
          }
        )
        .then((res) => {
          let fileName = window.decodeURI(
            res.headers["content-disposition"].split("=")[1]
          );
          const url = URL.createObjectURL(res.data);
          const a = document.createElement("a");
          a.href = url;
          a.download = fileName; // 设置下载的文件名
          a.click();
          URL.revokeObjectURL(url);
        });
    },
  },
  watch: {
    tab() {
      this.tabChange();
    },
  },
};
</script>
<style lang="less">
.item {
  margin-top: 10px;
  margin-right: 40px;
}

.teachers {
  padding: 0;
}

.teacher-item {
  display: flex;
  margin-bottom: 10px;
  font-size: 18px;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  cursor: pointer;

  &:hover {
    background: rgba(0, 0, 0, 0.1);
  }

  img {
    width: 70px;
    height: 70px;
    border-radius: 50%;
  }

  .tname {
    flex: 1;
    padding-left: 20px;
  }

  .tact {
    padding-right: 20px;
    color: #1890ff;
  }
}

.temp-name {
  font-size: 18px;
  text-align: center;
  line-height: 1.5;
}

.ques-item {
  font-size: 14px;
  margin-bottom: 24px;
}

.eval-result {
  font-size: 14px;
  font-weight: bold;
}

.result-table {
  width: 50%;
  margin: 30px auto;
  font-size: 14px;
  border: 1px solid rgba(0, 0, 0, 0.1);

  th,
  td {
    padding: 14px;
  }
}

.ot-item {
  width: 100px;

  .teacher-box {
    width: 100%;
    height: 100px;
    position: relative;
    cursor: pointer;

    img {
      width: 80%;
      height: 80%;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      position: absolute;
      border-radius: 50%;
    }
  }
}

.active-teacher {
  font-weight: bold;
  color: #1890ff;
  text-decoration: underline;
}

.result-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 2;
  font-size: 16px;
  padding: 10px 0;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-left: none;
  border-right: none;
}

.eval-result-t {
  font-size: 16px;
}

.suggest-item {
  display: flex;
  align-items: flex-start;

  img {
    width: 60px;
    height: 60px;
    border-radius: 50%;
  }

  .suggest-body {
    flex: 1;
    padding: 0px 0 0 16px;

    p {
      word-break: break-all;
      line-height: 1.5;
    }
  }
}

.el-radio__input.is-checked + span.el-radio__label {
  color: #1890ff !important;
  font-weight: bold;
  cursor: not-allowed;
}

.el-radio__input.is-disabled.is-checked .el-radio__inner::after {
  background-color: #1890ff !important;
}
.one-title {
  font-size: 16px;
  font-weight: 700;
  margin-top: 20px;
}
</style>
